import React, { Component } from 'react'

export default class SkletonCart extends Component {
    state = {
        cart: [
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
        ]
    }
    render() {
        return (
            <div className="dashboard-widgets p-3">

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {this.state.cart.map((cart) => (
                            <div className='br-15' key={cart.id} style={{ marginRight: '10px', boxShadow: "2px 4px 12px rgba(0, 0, 0, 0.04)" }}>
                                <div className='skeleton-box br-15 mt-1' style={{ width: '140px', height: '140px', backgroundColor: '#dedede' }}></div>
                                <div className='mt-3 br-10' style={{ width: '50%', height: '18px', backgroundColor: '#dedede' }}></div>
                                <div className='mt-2 br-10' style={{ width: '80%', height: '18px', backgroundColor: '#dedede' }}></div>
                                <div className='mt-2 br-10' style={{ width: '80%', height: '18px', backgroundColor: '#dedede' }}></div>
                                <div className='flexc pb-2'>
                                    <div className='mt-2 br-10 ' style={{ width: '30%', height: '20px', backgroundColor: '#dedede' }}></div>

                                </div>

                            </div>
                        ))}
                    </div>

                </div>

            </div >
        )
    }
}
